import React, { useState, useRef, useEffect } from "react";
import { Button, ButtonGroup } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomNavbar from "../../../components/CustomNavbar";
import SidebarConfig from "../../../components/SidebarConfig";
import UserMenuComponent from "../../../components/profile/UserMenuComponent";
import UserEducationComponent from "../../../components/profile/UserEducationComponent";
import {
  getDocs,
  getAreas,
  getCarpetas,
} from "../../../redux/gestorDocumental/actions";
import { getEmployee } from "../../../redux/employees/actions";
import config from "../../../config";

const EducationFunc = (props) => {
  //States
  const [show, setShow] = useState(false);
  //*Ref
  const childRef = useRef();
  // Redux
  // const userN = useSelector((store) => store.auth.username);
  const userId = useSelector((store) => store.auth.id);
  const userInfo = useSelector(store => store.employees.employee);
  // Dispatch
  const dispatch = useDispatch();
  const { areas, carpetas } = useSelector((store) => store.gestorDocumental);
  const { tipoDocumento } =
    config.gestorDocumental.educacion;
  //Metodos
  const onShowSidebar = () => setShow(show ? false : true);
  useEffect(() => {
    if(props.match.params.id && props.match.params.type){
      dispatch(
        getEmployee(props.match.params.id, parseInt(props.match.params.type))
      );
    }
  }, [dispatch, props.match.params.id, props.match.params.type]);

  useEffect(() => {
    if ((areas && areas.length === 0) || areas === "") {
      dispatch(getAreas());
    }
    if ((carpetas && carpetas.length === 0) || carpetas === "") {
      dispatch(getCarpetas());
    }
  }, [dispatch, areas, carpetas, props.iType]);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container-fluid">
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1">
            <h2 className="font-weight-bold d-flex justify-content-between align-items-center text-uppercase">
              {props.match.params.name}
              <ButtonGroup>
                <Button onClick={props.history.goBack} size="sm">
                  <i className="material-icons">keyboard_return</i>
                </Button>
                <UserMenuComponent
                  id={props.match.params.id}
                  name={props.match.params.name}
                  type={props.match.params.type}
                />
                <Button
                  variant="primary"
                  size="sm"
                  onClick={() => childRef.current.onAdd()}
                >
                  <i className="material-icons">add</i>
                </Button>
              </ButtonGroup>
            </h2>
            <hr />
            <h6>Empleado educación </h6>
          </div>
          <UserEducationComponent
            areas={areas} 
            carpetas={carpetas}
            ref={childRef}
            type={props.match.params.type}
            id={props.match.params.id}
            uet={1}
            userInfo={userInfo}
          />
        </div>
      </div>
    </>
  );
};

export default withRouter(EducationFunc);
